import { IHttpResponse, ILogService, IOnChangesObject, IQService, IScope, ITimeoutService } from 'angular'
import { FileItem } from 'angular-file-upload'
import { chain, forEach } from 'lodash'
import { Modal } from 'materialize-css'
import { BASE_CANDIDATO_API } from 'src/_candidato/comun/services/acceso-datos'
import { CVModel } from 'src/_candidato/data/cv/CVModel'
import { CVFilePreg } from 'src/_candidato/data/cv/CVResp'
import { CurriculumService } from 'src/_candidato/public/services/CurriculumService'
import {
  ICurriculumRequestAlta,
  ICurriculumState,
  IFeaturesPubl,
  IICuestionario,
  IICuestionarioBloque,
  IICuestionarioPreg,
  IItemMenu,
} from '../../../../model/candidato-api'
import { $candidatoPublicMod } from '../../candidato-public-mod'

class StartFormComponentCtrl {
  cuestionario!: IICuestionario<IICuestionarioBloque<IICuestionarioPreg>>
  menuopt!: IItemMenu
  params!: { [v: string]: any }
  appConfig!: IFeaturesPubl
  accesoPublico!: boolean

  aceptarTerminos = true
  aceptarRecaptcha = true
  modalAceptar = true

  $ready = false
  cvmodel: CVModel

  textosCV = false

  errorcapt = false
  erroraccept = false
  form = {
    recapResponse: '',
    dataaccept: false,
  }
  testCV: number = 7
  $loading = false
  $success = false
  $errorSesion = false
  $errorEnvio = false
  $errorEnvioMsg = ''
  modalInstance: Modal

  constructor(
    private $scope: IScope,
    private $element: JQLite,
    private $timeout: ITimeoutService,
    private $q: IQService,
    private $log: ILogService,
    private vcRecaptchaService: any,
    private CurriculumService: CurriculumService
  ) {}

  $onInit(): void {
    this.$log.info('[StartFormComponentCtrl] onInit')

    this.textosCV = this.appConfig.introCv

    this.aceptarTerminos = this.appConfig.acceptTerms || this.menuopt.accLo
    this.aceptarRecaptcha = this.appConfig.acceptRecaptcha || this.menuopt.accRc
    this.modalAceptar = this.aceptarRecaptcha || this.aceptarTerminos

    // this.__init()
  }

  $onChanges(changes: IOnChangesObject) {
    if (changes.cuestionario && changes.cuestionario.currentValue) {
      this.__init()
    }
  }

  private __init() {
    this.$ready = false

    this.cvmodel = new CVModel()
    this.$success = false
    this.$loading = false
    this.erroraccept = false
    this.errorcapt = false
    this.form = {
      recapResponse: '',
      dataaccept: false,
    }

    // forzar un cambio de modelo
    this.$ready = true
  }

  $postLink() {
    this.$timeout((_) => {
      let modalInstance = this.$element.find('#modal-send').modal({
        onCloseEnd: () => $('body').removeClass('modal-open').css('overflow', 'auto'),
      })
      this.modalInstance = M.Modal.getInstance(modalInstance[0])
    }, 1000)
  }

  sendCuestionario() {
    if (!this.cvmodel.validar()) {
      this.$log.info('Validación falla')
      return
    }

    this.$success = false
    this.$errorSesion = false
    this.$errorEnvio = false
    this.$errorEnvioMsg = ''

    if (this.modalAceptar) {
      if (this.aceptarRecaptcha) {
        this.vcRecaptchaService.reload()
      }

      this.form.dataaccept = false
      this.erroraccept = false
      this.errorcapt = false

      this.modalInstance.open()
      $('body').addClass('modal-open')
    } else {
      this.modalInstance.open()
      $('body').addClass('modal-open')

      this.sendCuestionarioConfirmed()
    }

    this.$log.debug(this.__req())
  }

  private sendCuestionarioConfirmed() {
    let pregFiles = this.cvmodel.files()

    this.$loading = true
    this.CurriculumService.sendCv(this.__req(), this.accesoPublico)
      .then(
        (cvStateResponse) => {
          let url = BASE_CANDIDATO_API + `api/_cv/n/${cvStateResponse.tkn}/f?_f=`

          let fd = new FormData()
          fd.append('tkn', cvStateResponse.tkn)
          fd.append('t', cvStateResponse._t)

          // al guardar, enviar todos los files
          chain(pregFiles)
            .forEach((pregFile) => {
              chain(pregFile.filesEnviar())
                .forEach(async (file) => {
                  await this.enviafile(file, pregFile, url, fd)
                })
                .value()
            })
            .value()

          this.$success = true
        },
        (err: IHttpResponse<ICurriculumState>) => {
          // alert('Ha habido un problema, por favor vuelva a intentarlo')

          // FIXME :gestionar el error

          this.form.dataaccept = false
          this.$log.warn('error al enviar el cuestionario', err)

          if (!this.accesoPublico && err?.status == 403) {
            this.$errorSesion = true
          } else {
            // gestionar el error

            this.$errorEnvio = true
            this.$errorEnvioMsg = 'There was a problem, please try again'
          }

          if (this.aceptarRecaptcha && this.vcRecaptchaService) {
            this.vcRecaptchaService.reload()
          }
        }
      )
      .finally(() => {
        this.$loading = false
      })
  }

  sendCuestionarioAgree() {
    // this.vcRecaptchaService.execute();

    this.$log.info('login', this.form)

    this.erroraccept = this.aceptarTerminos && !this.form.dataaccept
    if (this.erroraccept) return

    if (this.aceptarRecaptcha) {
      var recapResponse = this.vcRecaptchaService.getResponse() // returns the string response
      this.$log.info('recaptcha', recapResponse)

      if (recapResponse == '') {
        this.errorcapt = true
        return
      }
    }

    this.sendCuestionarioConfirmed()
  }

  relogin() {
    // cerrar el modal de envío
    this.modalInstance.close()

    window.open('/?_back=1#!/c/priv/login', '_target=_blank')
  }

  testSendFiles() {
    let pregFiles = this.cvmodel.files()

    let url = BASE_CANDIDATO_API + 'api/_cv/n/abc/f?idcv=' + this.testCV

    // al guardar, enviar todos los files
    forEach(pregFiles, (pregFile) => {
      forEach(pregFile.filesEnviar(), async (file) => {
        await this.enviafile(file, null, url, new FormData())

        this.$log.info('== Enviado!!!')
      })
    })
  }

  testClose() {
    window.open('/?_back=1&dev=1#!/c/priv/login', '_target=_blank')
  }

  private enviafile(f: FileItem, cvpreg: CVFilePreg, url: string, fd: FormData) {
    let $p = this.$q.defer()

    f.url = url + encodeURI(f.file.name)
    f.formData = [fd, this._formDataPreg(cvpreg)]
    f.onComplete = () => {
      $p.resolve()
    }

    f.upload()

    return $p.promise
  }

  private _formDataPreg(cvpreg: CVFilePreg) {
    if (!cvpreg) return new FormData()

    let fd = new FormData()

    fd.append('qref', cvpreg.idqref)
    fd.append('idx', cvpreg.idx)

    return fd
  }

  private __req() {
    let req: ICurriculumRequestAlta = {
      peticion: {
        idform: this.cuestionario.infoForm.idf,
        idmen: this.menuopt.idm,
      },

      resplist: this.cvmodel.respuestas(),

      verify: '',
    }

    this.$log.info('confirm', req)

    return req
  }

  rellenaTest() {
    // para cada respuesta, rellenar valor de prueba
    this.cvmodel.__rellenaTest()
  }
}

$candidatoPublicMod.component('startForm', {
  bindings: {
    // empresa: "<",
    cuestionario: '<',
    params: '<',
    menuopt: '<',
    appConfig: '<',
    accesoPublico: '<',
  },
  controller: StartFormComponentCtrl,
  template: require('./start-form.component.html'),
  //templateUrl: "../../../../app/ui/vs/prog/dev/templates/start-form/start-form.component.html"
})
